import type { IconDefinition } from '../../types'

export default {
  details: [32, 33, [], '', 'M16 22.2333C19.1664 22.2333 21.7333 19.6664 21.7333 16.4999C21.7333 13.3335 19.1664 10.7666 16 10.7666C12.8336 10.7666 10.2667 13.3335 10.2667 16.4999C10.2667 19.6664 12.8336 22.2333 16 22.2333Z'],
  name: 'uiDotFull',
  oldName: 'cusDotFull'
} as IconDefinition
